import { render } from "./PrTab.vue?vue&type=template&id=19cb30ab&scoped=true"
import script from "./PrTab.vue?vue&type=script&lang=js"
export * from "./PrTab.vue?vue&type=script&lang=js"

import "./PrTab.vue?vue&type=style&index=0&id=19cb30ab&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cb30ab"]])

export default __exports__